import Heading from '@shared/components/content/heading';
import Text from '@shared/components/content/text';
import { Badge } from '@shared/components/ui/badge';
import { SidebarTrigger, useSidebar } from '@shared/components/ui/sidebar';
import { cn } from '@shared/lib/utils';
import { ReactElement } from 'react';

import { Icons } from '@shared/components/content/icons';
import PageBreadcrumb, { Breadcrumb } from './page-breadcrumb';
import { PageHeaderToolbarProps } from './page-header-toolbar';

interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string | ReactElement;
  nameTag?: string;
  description?: string;
  nameActions?: ReactElement;
  toolbar?: ReactElement<PageHeaderToolbarProps>;
  tabs?: ReactElement;
  includeBreadcrumb?: boolean;
  breadcrumbs?: Breadcrumb[];
  headingTestId?: string;
}

export function PageHeader({
  name,
  nameTag,
  description,
  nameActions,
  className,
  toolbar,
  tabs,
  includeBreadcrumb = true,
  breadcrumbs,
  headingTestId,
}: PageHeaderProps) {
  const { isMobile } = useSidebar();
  return (
    <div className={cn('min-h-[90px] mb-4 pt-1', className)}>
      <div className="flex min-h-5 items-center">
        {isMobile && <SidebarTrigger icon={<Icons.menu />} className="mr-1" />}
        {includeBreadcrumb && <PageBreadcrumb breadcrumbs={breadcrumbs} />}
      </div>
      <div className="flex items-center">
        {typeof name === 'string' ? (
          <Heading
            variant="subtitle"
            className="font-semibold"
            data-testid={headingTestId}
          >
            {name}
          </Heading>
        ) : (
          name
        )}
        {nameTag && <Badge className="ml-3">{nameTag}</Badge>}
        <div className="ml-auto">{toolbar}</div>
      </div>
      {description && (
        <Text variant="subtle" className="mt-[2px] max-w-xl">
          {description}
        </Text>
      )}
      {nameActions && <div className="mt-1">{nameActions}</div>}
      {tabs && <div className="mt-2">{tabs}</div>}
    </div>
  );
}
